<template>
  <v-divider class="leftPanel mt-5" />
</template>

<script>
export default {
  name: "CustomDivider",
};
</script>

<style scoped></style>
